/**
 * Dual ATC mobile toggle (spec 0068 / ADR-047).
 * Só o par Apple+WhatsApp expande. ATC+wishlist: coração clica direto (sem expand).
 * Colapsado = só troca data-gm-dual-expanded; aberto = deixa a ação passar.
 */
(function () {
  const MQ = '(max-width: 749px)';
  const TOGGLE = '[data-gm-dual-toggle]';

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function sideOf(el) {
    if (!(el instanceof Element)) return null;
    if (el.closest('.gm-dual-atc__wa')) return 'secondary';
    if (el.closest('.gm-dual-atc__atc') || el.closest('[data-gm-pdp-apple-pay]')) return 'primary';
    return null;
  }

  /** ATC + wishlist: sem expand — coração executa na hora. */
  function isStaticSecondaryPair(root) {
    return (
      root.hasAttribute('data-gm-atc-slot') ||
      Boolean(root.querySelector('[data-gm-wishlist]'))
    );
  }

  function onClick(e) {
    if (!isMobile()) return;
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;

    const root = target.closest(TOGGLE);
    if (!root) return;
    if (isStaticSecondaryPair(root)) return;

    const side = sideOf(target);
    if (!side) return;

    const expanded = root.getAttribute('data-gm-dual-expanded') || 'primary';
    if (side === expanded) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    root.setAttribute('data-gm-dual-expanded', side);
  }

  document.addEventListener('click', onClick, true);
})();
